<template>
  <div class="page-container">
    <h1 class="page-title">Page Not Found!</h1>
  </div>
</template>

<script lang="js">
import Vue from 'vue';

export default Vue.extend({
  name: 'NotFound',
  data: () => ({
  }),
  created: function () {

  },
  methods: {}
});
</script>

<style></style>
